import clsx from 'clsx'

import { useClock } from '../../lib/data'
import { nativeRecorderAvailable } from '../../lib/native-recorder'
import { PHONE_MAY_MISS_NOTE, phoneMayMissIt } from '../../lib/phone-alarms'
import { clockInstant } from '../../lib/time'

/**
 * THE ONE QUIET LINE under a reminder time that is less than 15 minutes away, on any surface that
 * is not the phone app (lib/phone-alarms.ts says why). Renders nothing otherwise — including while
 * the clock has not been read, because "is this soon?" with no "now" is a guess.
 *
 * `reminderAt` is the instant being set (ISO), or null when none is set yet. "Now" is the app
 * clock (`useClock`, re-read live while this is mounted), never a render-time `Date.now()`.
 */
export function PhoneMayMissNote({
  reminderAt,
  className,
}: {
  reminderAt: string | null | undefined
  /** Placement and SIZE — the size is the host's microcopy size, so it is passed, not assumed. */
  className?: string
}) {
  const { data: clock } = useClock({ live: true })
  const nowMs = clock ? clockInstant(clock.date, clock.minutesIntoDay) : null
  const atMs = reminderAt ? Date.parse(reminderAt) : null
  if (!phoneMayMissIt(atMs, nowMs, nativeRecorderAvailable())) return null
  return (
    <p className={clsx('font-normal leading-[1.4] text-microcopy text-pretty', className ?? 'text-[11px]')}>
      {PHONE_MAY_MISS_NOTE}
    </p>
  )
}
